// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"d1c826c6","213":"a170eda4","337":"c5a4bcf5","453":"4af4c337","634":"809cb501","667":"05b212fb"}[chunkId] + ".chunk.js";
};